// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"18":"564df448","237":"7b0b06e3","331":"f7cf3660","375":"3123ab56","486":"06b2226d","639":"cc741697","654":"efac6304","665":"45c341a2","731":"40b7cb1a","952":"bd116b24","968":"0d13d733","991":"6bfe7be1"}[chunkId] + ".chunk.js";
};